import React, { useState, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import { MenuItem, MenuList, ClickAwayListener, Popper, Grow, ListItemIcon, ListItemText } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';

import useWindowSize from '@rehooks/window-size';

export type PublishMenuAnchorType = { open: boolean, anchorPosition: { left: number; top: number; }; id: string; }
export type PublishMenuFunctionsType = {
  publish: (id: string) => void;
}
type HandlingKey = keyof PublishMenuFunctionsType

type PublishMenuProps = {
  menuAnchor?: PublishMenuAnchorType;
  onClose: () => void;
  functions: PublishMenuFunctionsType;
}
const PublishMenu: React.FC<PublishMenuProps> = ({ menuAnchor, onClose, functions }) => {
  const windowSize = useWindowSize();
  type PositionType = { left?: number; right?: number; top?: number; bottom?: number }
  const [position, setPosition] = useState<PositionType>({});
  const [enable, setEnable] = useState(false);

  const handlingExe = (key: HandlingKey) => {
    if (!menuAnchor) return;

    switch (key) {
      case 'publish': functions.publish(menuAnchor.id); break;
    }
    onClose();
  }
  const toggleEnable = () => {
    setEnable(false);
    if (menuAnchor !== undefined) setTimeout(() => setEnable(true), 280)
  }

  useEffect(() => {
    if (!menuAnchor) return;
    const menuWidth = 424;
    const menuHight = 60 * Object.keys(functions).length;
    let left: number;
    let top: number;
    if (menuAnchor.anchorPosition.left + menuWidth + 16 > windowSize.innerWidth) left = menuAnchor.anchorPosition.left - menuWidth;
    else left = menuAnchor.anchorPosition.left;
    if (menuAnchor.anchorPosition.top + menuHight + 16 > windowSize.innerHeight) top = menuAnchor.anchorPosition.top - menuHight;
    else top = menuAnchor.anchorPosition.top;
    setPosition({ left, top });
  }, [menuAnchor])

  useEffect(() => {
    toggleEnable();
  }, [menuAnchor])

  return (
    <Popper open={Boolean(menuAnchor?.open)} role={undefined} transition disablePortal
      style={{
        zIndex: 998,
        pointerEvents: enable ? 'auto' : 'none',
        ...position
      }}
    >
      { ({ TransitionProps, placement }) => (
        <Grow
          { ...TransitionProps }
          style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
        >
        <Paper>
          <ClickAwayListener onClickAway={onClose}>
            <MenuList>
              <MenuItem key="publish" onClick={() => handlingExe('publish')}>
                <ListItemIcon><PublishIcon fontSize="small" /></ListItemIcon>
                <ListItemText>ショップの商品として公開・アップデートする</ListItemText>
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Grow>
    )}
    </Popper>
  );
}

export default PublishMenu;
